import { EquipmentStateName } from '@frontend/equipment/types';
import { StockExtendedClient } from '@frontend/stock/api';
import { StockExtended } from '@frontend/stock/types';
import { FormattedMessage } from 'react-intl';

import KioskList from '../../../components/kiosk-list.component';
import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { ProductCard } from '../browse-products-by-categories/product-card/product-card.component';
import useLendingReviewOverview from './lending-review-overview.controller';

const ID = 'lending-review-overview';

const LendingReviewOverview = () => {
    const viewProps = useLendingReviewOverview();

    return (
        <WizardScreenContainer
            id={ID}
            loadingModal={{
                show: viewProps.isProcessing
            }}>
            <div className='flex flex-col items-start justify-start gap-3 self-stretch'>
                <div className='text-foreground-default justify-end'>
                    <FormattedMessage
                        defaultMessage='Review products that were recently returned.'
                        id='kiosk.wizard.lending-review-overview.instruction'
                        description='Instruction text on the lending review overview screen, prompting users to review recently returned products'
                    />
                </div>
                <KioskList<StockExtended>
                    id='lending-return-overview'
                    fetch={(args) =>
                        StockExtendedClient.fetchReusableStocksExtended({ ...args, equipment_state: EquipmentStateName.EQUIPMENT_REVIEW_REQUIRED })
                    }
                    rowElement={(stock) => (
                        <ProductCard
                            product_id={stock.product?.entity_id}
                            onClick={(product) => viewProps.onSelect(stock, product)}
                        />
                    )}
                    emptyText={
                        <FormattedMessage
                            id='kiosk.wizard.review-overview.no-products'
                            defaultMessage='No products to review'
                        />
                    }
                />
            </div>
        </WizardScreenContainer>
    );
};

export default LendingReviewOverview;
